import React from 'react'
import ReactDOM from 'react-dom/client'
import Raupō from './assets/raupo';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import NotFound from './components/pages/NotFound';
import FooterSpace from './components/footer/FooterSpace';
import InformationPage from './components/pages/InformationPage';
import { Provider } from 'react-redux';
import appStore from './utils/appStore';
import HeaderSpace from './components/header/HeaderSpace';
import Modal from './components/modal/Modal';
import HomePage from './components/pages/HomePage';
import UpdatesPage from './components/pages/UpdatesPage';
import ContactPage from './components/pages/ContactPage';

const App = () => {

    return (
        <>  
            <Raupō nama={40} />
            <HeaderSpace />
            <Outlet />
            <FooterSpace />
            <Modal />
        </>
    )
};

const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                index: true,
                element: <HomePage />
            },
            {
                path: "about",
                element: <InformationPage />
            },
            {
                path: "updates",
                element: <UpdatesPage />
            },
            {
                path: "contact",
                element: <ContactPage />
            }
        ],
        errorElement: (<Provider store={appStore} ><NotFound /></Provider>)
    }
])

const rootDIV = document.getElementById('root');

const root = ReactDOM.createRoot(rootDIV as HTMLElement);
root.render(
    <Provider store={appStore}>
        <RouterProvider router={appRouter} />
    </Provider>
);